import React, { useState } from 'react';

const FONT = '"Nunito","Baloo 2",sans-serif';

export default function GrammarRuleCard({ payload, onAnswer, disabled }) {
  const [done, setDone] = useState(false);
  const click = (got) => {
    if (done) return;
    setDone(true);
    if (onAnswer) onAnswer({ is_correct: got, user_answer: got ? 'got_it' : 'unsure' });
  };
  return (
    <div style={{ maxWidth: 560, margin: '0 auto', fontFamily: FONT }}>
      <div
        style={{
          padding: 22,
          borderRadius: 14,
          background: '#f0fdf4',
          border: '2px solid #86efac',
        }}
      >
        <div style={{ fontSize: 22, fontWeight: 800, color: '#14532d' }}>
          📚 {payload.title}
        </div>
        {payload.level ? (
          <div style={{ fontSize: 13, color: '#16a34a', marginTop: 4 }}>
            Cambridge {payload.level}
          </div>
        ) : null}

        {payload.formula ? (
          <div
            style={{
              marginTop: 14,
              padding: 10,
              background: '#fff',
              borderRadius: 10,
              border: '1px dashed #16a34a',
              fontFamily: 'monospace',
              fontSize: 16,
            }}
          >
            <strong>Công thức:</strong> {payload.formula}
          </div>
        ) : null}

        {payload.usage_vi ? (
          <div style={{ marginTop: 12 }}>
            <strong>Cách dùng:</strong>
            <div style={{ marginTop: 4, color: '#374151' }}>{payload.usage_vi}</div>
          </div>
        ) : null}

        {payload.example_en ? (
          <div
            style={{
              marginTop: 14,
              padding: 10,
              background: '#fff',
              borderRadius: 10,
              fontStyle: 'italic',
            }}
          >
            "{payload.example_en}"
            {payload.example_vi ? (
              <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
                {payload.example_vi}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      {!disabled ? (
        <div style={{ display: 'flex', gap: 12, marginTop: 16, justifyContent: 'center' }}>
          <button onClick={() => click(false)} style={btn('#ef4444')}>
            Chưa hiểu
          </button>
          <button onClick={() => click(true)} style={btn('#10b981')}>
            Đã hiểu
          </button>
        </div>
      ) : null}
    </div>
  );
}

function btn(bg) {
  return {
    padding: '12px 24px',
    border: 'none',
    borderRadius: 10,
    background: bg,
    color: '#fff',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
  };
}
